/* Doxie.us brand interactions */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* reveal on scroll */
  function reveal(){
    var els=document.querySelectorAll('.dx-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  /* 3D stage follows pointer */
  function stage(){
    if(reduce)return;
    document.querySelectorAll('[data-dx-stage]').forEach(function(st){
      var inner=st.querySelector('.dx-stage__inner');if(!inner||st.__dx)return;st.__dx=1;
      st.addEventListener('pointermove',function(e){var r=st.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;inner.style.transform='rotateY('+(x*14)+'deg) rotateX('+(-y*10)+'deg)';});
      st.addEventListener('pointerleave',function(){inner.style.transform='';});
    });
  }
  /* delivery estimate: handling 0-3 days + transit 3-14 days (shipping policy) */
  function eta(){
    document.querySelectorAll('[data-dx-eta]').forEach(function(el){
      var a=+el.getAttribute('data-min')||3,b=+el.getAttribute('data-max')||17,d=new Date();
      function f(n){var x=new Date(d.getTime()+n*864e5);return x.toLocaleDateString(undefined,{month:'short',day:'numeric'});}
      var out=el.querySelector('[data-dx-eta-out]');if(out)out.textContent=f(a)+' – '+f(b);
    });
  }
  /* sticky add to cart */
  function satc(){
    var bar=document.querySelector('[data-dx-satc]');if(!bar||bar.__dx)return;bar.__dx=1;
    var btn=document.querySelector('product-form [name="add"]');if(!btn){bar.remove();return;}
    var price=bar.querySelector('[data-dx-satc-price]'),label=bar.querySelector('[data-dx-satc-label]');
    function sync(){var p=document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');if(p&&price)price.textContent=p.textContent.trim();if(label){label.textContent=btn.disabled?(btn.textContent.trim()||'Sold out'):bar.getAttribute('data-label');}bar.querySelector('button').disabled=btn.disabled;}
    new IntersectionObserver(function(en){var e=en[0];bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);sync();}).observe(btn);
    bar.querySelector('button').addEventListener('click',function(){
      var picker=document.querySelector('variant-selects, variant-radios');
      if(btn.disabled){(picker||btn).scrollIntoView({behavior:'smooth',block:'center'});return;}
      btn.click();
    });
    document.addEventListener('change',function(e){if(e.target.closest('variant-selects, variant-radios'))setTimeout(sync,400);});
  }
  /* cart trust row under checkout buttons (drawer + cart page) */
  function cartTrust(){
    var tpl=document.getElementById('dx-ct-tpl');if(!tpl)return;
    document.querySelectorAll('.cart__ctas').forEach(function(ctas){
      var host=ctas.parentNode;if(!host||host.querySelector('.dx-ct'))return;
      var dyn=host.querySelector('.cart__dynamic-checkout-buttons');
      (dyn||ctas).insertAdjacentElement('afterend',tpl.content.firstElementChild.cloneNode(true));
    });
  }
  function watchCart(){
    cartTrust();
    ['cart-drawer','#main-cart-footer','cart-drawer-items','.cart__footer-wrapper'].forEach(function(sel){
      var el=document.querySelector(sel);if(el&&!el.__dxo){el.__dxo=1;new MutationObserver(cartTrust).observe(el,{childList:true,subtree:true});}
    });
  }
  /* size chart popup from description images/tables */
  function sizeChart(){
    document.querySelectorAll('[data-dx-sc]').forEach(function(box){
      if(box.__dx)return;box.__dx=1;
      var src=box.querySelector('[data-dx-sc-src]'),body=box.querySelector('[data-dx-sc-body]');if(!src||!body)return;
      var frag=src.content,found=0,re=/size|chart|measur|guide/i;
      /* group images that sit together (no real text between them); show a group if it follows
         size-related text or if any image in it looks like a size chart */
      var txtRe=/size chart|size guide|sizing|size selection|how to measure|measurements?\b|choose the (right|correct) size/i,started=false,groups=[],g=null;
      var walker=document.createTreeWalker(frag,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT),n;
      while((n=walker.nextNode())){
        if(n.nodeType===3){var t=n.textContent.trim();if(txtRe.test(t))started=true;if(t.length>=20)g=null;continue;}
        if(n.tagName!=='IMG')continue;
        if(!g){g={imgs:[],hit:started};groups.push(g);}
        g.imgs.push(n);
        if(re.test((n.getAttribute('src')||'')+' '+(n.getAttribute('alt')||'')))g.hit=true;
      }
      groups.forEach(function(gr){if(!gr.hit)return;gr.imgs.forEach(function(im){var c=im.cloneNode(true);c.removeAttribute('style');c.removeAttribute('width');c.removeAttribute('height');c.loading='lazy';body.appendChild(c);found++;});});
      frag.querySelectorAll('table').forEach(function(t){if(re.test(t.textContent)||/\b(xs|s|m|l|xl)\b/i.test(t.textContent)){var w=document.createElement('div');w.className='dx-sc__tbl';w.appendChild(t.cloneNode(true));body.appendChild(w);found++;}});
      if(!found)return;
      box.hidden=false;
      var dlg=box.querySelector('dialog');
      box.querySelector('[data-dx-sc-open]').addEventListener('click',function(){if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','');});
      box.querySelector('[data-dx-sc-close]').addEventListener('click',function(){dlg.close();});
      dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close();});
    });
  }
  /* frequently bought together */
  function fbt(){
    document.querySelectorAll('[data-dx-fbt]').forEach(function(box){
      if(box.__dx)return;box.__dx=1;
      var main;try{main=JSON.parse(box.querySelector('[data-dx-fbt-main]').textContent);}catch(e){return;}
      var picks=[];try{picks=JSON.parse(box.querySelector('[data-dx-fbt-picks]').textContent)||[];}catch(e){}
      var limit=+box.getAttribute('data-limit')||2,root=box.getAttribute('data-root')||'/',cur=box.getAttribute('data-currency')||'USD';
      function money(c){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100);}catch(e){return (c/100).toFixed(2);}}
      function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML;}
      function fromRec(p){return {id:p.id,title:p.title,url:p.url,image:(p.featured_image||'').replace(/^\/\//,'https://'),available:p.available,variants:(p.variants||[]).map(function(v){return {id:v.id,title:v.title,price:v.price,compare_at_price:v.compare_at_price||0,available:v.available};})};}
      function load(){
        if(picks.length)return Promise.resolve(picks);
        var base=root.replace(/\/$/,'')+'/recommendations/products.json?product_id='+main.id+'&limit='+(limit+4);
        return fetch(base+'&intent=complementary').then(function(r){return r.ok?r.json():{products:[]};}).then(function(j){
          var a=(j.products||[]);if(a.length)return a.map(fromRec);
          return fetch(base+'&intent=related').then(function(r){return r.json();}).then(function(j){return (j.products||[]).map(fromRec);});
        }).catch(function(){return [];});
      }
      load().then(function(list){
        list=list.filter(function(p){return p.id!==main.id&&p.available&&p.variants.some(function(v){return v.available;});}).slice(0,limit);
        if(!list.length)return;
        var items=[{p:main,main:true}].concat(list.map(function(p){return {p:p};}));
        var imgs=box.querySelector('[data-dx-fbt-imgs]'),ul=box.querySelector('[data-dx-fbt-list]');
        items.forEach(function(it,i){
          if(i)imgs.insertAdjacentHTML('beforeend','<span class="dx-fbt__plus">+</span>');
          imgs.insertAdjacentHTML('beforeend','<a href="'+esc(it.p.url)+'" data-i="'+i+'">'+(it.p.image?'<img src="'+esc(it.p.image)+'" alt="'+esc(it.p.title)+'" loading="lazy">':'')+'</a>');
          var av=it.p.variants.filter(function(v){return v.available;});
          var sel=(!it.main&&av.length>1)?'<select data-i="'+i+'" aria-label="Option for '+esc(it.p.title)+'">'+av.map(function(v){return '<option value="'+v.id+'">'+esc(v.title)+'</option>';}).join('')+'</select>':'';
          it.variant=it.main?null:av[0];
          ul.insertAdjacentHTML('beforeend','<li class="dx-fbt__item"><input type="checkbox" checked data-i="'+i+'" aria-label="Include '+esc(it.p.title)+'"'+(it.main?' disabled':'')+'><div>'+(it.main?'<b>This item:</b> ':'')+'<a href="'+esc(it.p.url)+'">'+esc(it.p.title)+'</a>'+(it.main?'<small data-dx-fbt-mainv></small>':'')+sel+'</div><div class="dx-fbt__price" data-price="'+i+'"></div></li>');
          it.on=true;
        });
        function mainVariant(){
          var input=document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
          var id=input?+input.value:0;
          return main.variants.filter(function(v){return v.id===id;})[0]||main.variants.filter(function(v){return v.available;})[0]||main.variants[0];
        }
        function render(){
          var tot=0,cmp=0,n=0;items[0].variant=mainVariant();
          var mv=box.querySelector('[data-dx-fbt-mainv]');if(mv)mv.textContent=items[0].variant&&items[0].variant.title!=='Default Title'?items[0].variant.title:'';
          items.forEach(function(it,i){
            var v=it.variant,cell=box.querySelector('[data-price="'+i+'"]');
            cell.innerHTML=v?money(v.price)+(v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s>':''):'';
            var a=imgs.querySelector('a[data-i="'+i+'"]');if(a)a.classList.toggle('is-off',!it.on);
            if(it.on&&v){tot+=v.price;cmp+=Math.max(v.compare_at_price,v.price);n++;}
          });
          box.querySelector('[data-dx-fbt-total]').textContent=money(tot);
          box.querySelector('[data-dx-fbt-compare]').textContent=cmp>tot?money(cmp):'';
          var b=box.querySelector('[data-dx-fbt-add]');b.textContent=n>1?'Add all '+n+' to cart':'Add to cart';
          b.disabled=!items[0].variant||!items[0].variant.available;
        }
        box.addEventListener('change',function(e){
          var i=+e.target.getAttribute('data-i');if(isNaN(i))return;
          if(e.target.type==='checkbox')items[i].on=e.target.checked;
          if(e.target.tagName==='SELECT')items[i].variant=items[i].p.variants.filter(function(v){return v.id===+e.target.value;})[0];
          render();
        });
        document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('variant-selects, variant-radios, product-form'))setTimeout(render,300);});
        box.querySelector('[data-dx-fbt-add]').addEventListener('click',function(){
          var btn=this,err=box.querySelector('[data-dx-fbt-err]');err.hidden=true;
          var payload=items.filter(function(it){return it.on&&it.variant;}).map(function(it){return {id:it.variant.id,quantity:1};});
          var drawer=document.querySelector('cart-drawer');
          var body={items:payload};
          if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=location.pathname;}
          btn.disabled=true;var old=btn.textContent;btn.textContent='Adding…';
          fetch(root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
            .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
            .then(function(j){
              btn.textContent=old;btn.disabled=false;
              if(drawer&&drawer.renderContents&&j.sections){drawer.classList.remove('is-empty');j.id=payload[0].id;drawer.renderContents(j);}
              else location.href=root.replace(/\/$/,'')+'/cart';
            })
            .catch(function(e){btn.textContent=old;btn.disabled=false;err.textContent=(e&&(e.description||e.message))||'Could not add to cart. Please try again.';err.hidden=false;});
        });
        render();box.hidden=false;
      });
    });
  }
  function init(){reveal();stage();eta();satc();watchCart();sizeChart();fbt();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
